/**
 * Which engagement modals open, and how many times per show.
 *
 * A provisioned writer (key ready, still being set up, or stopped) never
 * sees connect-your-key / OpenRouter onboarding. Own-key accounts still do.
 * Two published copies of the same title and content are one show.
 */

export const EXPLAINER_MESSAGE_TYPE = 'explainer';

export function engagementContentKey(message) {
  return `${message?.title ?? ''}\0${message?.content ?? ''}`;
}

export function isExplainerMessage(message) {
  return message?.message_type === EXPLAINER_MESSAGE_TYPE;
}

export function isConnectKeyOnboarding(message) {
  const blob = `${message?.title || ''}\n${message?.content || ''}`.toLowerCase();
  if (!blob.includes('openrouter')) return false;
  return blob.includes('api key') || blob.includes('connect your');
}

export function appProvisionedWriter(status) {
  const provisioning = status?.key_provisioning;
  return provisioning === 'pending' || provisioning === 'ready' || provisioning === 'blocked';
}

export function shouldPresentEngagementMessage(message, {
  presentedIds,
  presentedContentKeys,
  sessionShownIds,
  writerStatus,
} = {}) {
  if (!message?.id) return false;
  // Explainers never open on their own. A link asks for one by id.
  if (isExplainerMessage(message)) return false;
  if (presentedIds?.has(message.id)) return false;
  if (sessionShownIds?.includes(message.id)) return false;
  const contentKey = engagementContentKey(message);
  if (presentedContentKeys?.has(contentKey)) return false;
  if (appProvisionedWriter(writerStatus) && isConnectKeyOnboarding(message)) return false;
  return true;
}
